"use strict";
exports.__esModule = true;
exports.DeliveryProviderLookupType = void 0;
var DeliveryProviderLookupType;
(function (DeliveryProviderLookupType) {
    DeliveryProviderLookupType[DeliveryProviderLookupType["ServiceLevels"] = 0] = "ServiceLevels";
    DeliveryProviderLookupType[DeliveryProviderLookupType["VehicleTypes"] = 1] = "VehicleTypes";
    DeliveryProviderLookupType[DeliveryProviderLookupType["ShippingOrigins"] = 2] = "ShippingOrigins";
    DeliveryProviderLookupType[DeliveryProviderLookupType["DeliveryTypes"] = 3] = "DeliveryTypes";
    DeliveryProviderLookupType[DeliveryProviderLookupType["AgeRestrictions"] = 4] = "AgeRestrictions";
    DeliveryProviderLookupType[DeliveryProviderLookupType["WhiteGloves"] = 5] = "WhiteGloves";
})(DeliveryProviderLookupType = exports.DeliveryProviderLookupType || (exports.DeliveryProviderLookupType = {}));
//# sourceMappingURL=delivery_provider_lookup_item.js.map